import React from "react";
import { Header } from "@/components/Header";

const TermsPage = () => (
  <div className="min-h-screen bg-white">
    <Header />
    <div className="container mx-auto px-6 py-12 max-w-4xl">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms of Service</h1>
      <div className="prose prose-gray max-w-none">
        <p className="text-gray-600 mb-6">Last updated: January 2026</p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">1. Acceptance of Terms</h2>
        <p className="text-gray-600 mb-4">By accessing SKI AXIS, you agree to these Terms of Service. SKI AXIS is operated by SKI Asia Pacific FZCO, registered in Dubai Silicon Oasis, UAE.</p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">2. Services</h2>
        <p className="text-gray-600 mb-4">SKI AXIS provides a governance-focused accelerator platform connecting startups, founders, investors, and mentors. Services include application evaluation, masterclass programs, and investor networking.</p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">3. User Accounts</h2>
        <p className="text-gray-600 mb-4">Users must provide accurate information during registration. You are responsible for maintaining the confidentiality of your account credentials.</p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">4. Payments</h2>
        <p className="text-gray-600 mb-4">Program fees are processed through Stripe. All payments are final unless otherwise specified. Refund requests must be submitted within 7 days of payment.</p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">5. Intellectual Property</h2>
        <p className="text-gray-600 mb-4">The SKI Three-Layer Governance Model is EU IPO-registered. All content, frameworks, and materials remain the property of SKI Asia Pacific.</p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">6. Privacy</h2>
        <p className="text-gray-600 mb-4">Your data is handled according to our Privacy Policy. We do not share personal information with third parties without consent.</p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">7. Contact</h2>
        <p className="text-gray-600 mb-4">For questions regarding these terms, contact: accelerator@skiasiapacific.com</p>
        
        <div className="mt-12 p-6 bg-gray-50 rounded-lg">
          <p className="text-sm text-gray-500"><strong>SKI Asia Pacific FZCO</strong><br />IFZA Property FZCO, Building A1<br />Dubai Digital Park, Dubai Silicon Oasis<br />United Arab Emirates</p>
        </div>
      </div>
    </div>
  </div>
);

export default TermsPage;
